import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Search, Calendar, FileText, ChevronRight } from "lucide-react";

const actions = [
  {
    to: "/chat",
    title: "Get AI Guidance",
    subtitle: "Ask your question for free",
    icon: MessageSquare,
    bg: "bg-amber-50",
    iconColor: "text-amber-600",
  },
  {
    to: "/lawyers",
    title: "Find a Lawyer",
    subtitle: "Search by issue or city",
    icon: Search,
    bg: "bg-blue-50",
    iconColor: "text-[#1E3A8A]",
  },
  {
    to: "/dashboard?tab=consults",
    title: "My Consultations",
    subtitle: "View upcoming & past",
    icon: Calendar,
    bg: "bg-emerald-50",
    iconColor: "text-emerald-600",
  },
  {
    to: "/my-records",
    title: "My Documents",
    subtitle: "Manage KYC & files",
    icon: FileText,
    bg: "bg-purple-50",
    iconColor: "text-purple-600",
  },
];

export function QuickActions() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {actions.map((a) => (
          <Link
            key={a.to}
            to={a.to}
            className="group flex items-center gap-4 bg-white border border-slate-200 rounded-2xl p-4 hover:shadow-lg hover:-translate-y-0.5 transition-all"
          >
            <div className={`h-12 w-12 rounded-xl ${a.bg} ${a.iconColor} grid place-items-center shrink-0`}>
              <a.icon size={22} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-[#0A2540] text-sm">{a.title}</p>
              <p className="text-xs text-slate-500 truncate">{a.subtitle}</p>
            </div>
            <ChevronRight size={18} className="text-slate-300 group-hover:text-[#0A2540] transition-colors" />
          </Link>
        ))}
      </div>
    </section>
  );
}

export default QuickActions;
